module.exports = "<navigation></navigation>\n<div class=\"view-wrapper\">\n    <router-outlet></router-outlet>\n</div>"